import { QueryClient } from "@tanstack/react-query";
import { APIError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The UI is bound to a local server we control; aggressive refetch isn't
      // worth the noise. Tune per-page if needed.
      staleTime: 30_000,
      retry: (failureCount, err) => {
        // Don't retry auth failures — the user needs to log in, not wait.
        if (err instanceof APIError && (err.status === 401 || err.status === 403)) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
